/** Longest curated list of a city, manual items included. Mirrors the backend (PARTNER_CURATED_LIST_MAX_ITEMS). */
export const CURATED_LIST_MAX_ITEMS = 50;

export interface CuratedLimitState {
  count: number;
  max: number;
  /** At the limit: Add is disabled until an item is removed. */
  isFull: boolean;
  /** A list saved before the limit existed can be longer; Save is blocked until it is cut. */
  isOver: boolean;
  canAdd: boolean;
  /** Items to remove to fit the limit. */
  extra: number;
}

export function getCuratedLimitState(
  count: number,
  max: number = CURATED_LIST_MAX_ITEMS,
): CuratedLimitState {
  return {
    count,
    max,
    isFull: count >= max,
    isOver: count > max,
    canAdd: count < max,
    extra: Math.max(0, count - max),
  };
}

/** Appends a product; a duplicate or a full list returns the same array. */
export function addToCurated<T extends { productCode: string }>(
  current: T[],
  product: T,
  max: number = CURATED_LIST_MAX_ITEMS,
): T[] {
  if (current.length >= max) return current;
  if (current.some((item) => item.productCode === product.productCode)) {
    return current;
  }
  return [...current, product];
}
